<div class="services-list">
  <div id="services-list" class="page-wrapper placeholder-glow">
    <div class="services-title-search-container">
      <h2 i18n="@@parta-my-apps-apply-for">Apply for</h2>
      <div class="service-search-container">
        <label
          for="filterServicesInput"
          class="far fa-search services-search-icon"
        ></label>
        <input
          id="filterServicesInput"
          [(ngModel)]="filterServicesSearch"
          (keyup)="filterServices()"
          [ngClass]="{ 'has-value': filterServicesSearch.length }"
        />
      </div>
    </div>
    <div #serviceFilters class="services-filters placeholder">
      <ul *ngIf="serviceCategories.length" class="service-categories">
        <li
          i18n="@@All topics"
          (click)="toggleServiceCategory()"
          [ngClass]="{ active: !currentServiceCategories.length }"
        >
          All topics
        </li>
        <li
          *ngFor="let serviceCategory of serviceCategories"
          (click)="toggleServiceCategory(serviceCategory)"
          [ngClass]="{ active: isCategoryActive(serviceCategory.category_id) }"
        >
          {{ serviceCategory.name }}
        </li>
      </ul>
    </div>
    <div #serviceItems class="services-items placeholder">
      <div class="fancy-placeholder"></div>
      <a
        [routerLink]="['/services', service.service_id]"
        *ngFor="let service of services; let i = index"
        class="service-item"
        style="--listIndex: {{ i }}"
      >
        <span class="service-name-container">
          <span class="service-name">{{ service.name }}</span>
          <div class="service-description" *ngIf="service.description">
            {{ service.description }}
          </div>
        </span>
        <span class="service-icon">
          <img
            *ngIf="service.icon_url"
            [src]="service.icon_url | safe: 'url'"
            alt=""
            class="item-img"
          />
          <i
            *ngIf="!service.icon_url"
            class="fad fa-file-contract service-fallback-icon"
          ></i>
        </span>
      </a>
    </div>
  </div>
</div>
